/* Extracted from snippets/fon-klaviyo-force-oos.liquid (was an inline parser-time jQuery block).
   Loaded with `defer` from the same file, so it runs after footer jQuery.

   Two openers: the nav's #fon-twostrong-oos-button, and [data-ts-oos-open] —
   the V88 TwoStrong buy box's waitlist button (Emily, 2026-10-12: the V88
   page uses the "Launching Soon" popup the live PDP uses, not the teaser's
   Reserve Your Spot modal). */
(function () {
      if (typeof jQuery === 'undefined') return;
      jQuery(function ($) {
        $(document).on('click', '#fon-twostrong-oos-button, [data-ts-oos-open]', function (e) {
          e.preventDefault();
          if (!$.magnificPopup) return;
          /* layout/theme.liquid defers Klaviyo to the first scroll or touch; a
             click can come first. Same guard as v88-buybox.js. */
          if (!document.querySelector('script[src^="https://static.klaviyo.com/onsite/js/"]')) {
            var k = document.createElement('script');
            k.src = 'https://static.klaviyo.com/onsite/js/YnKpzp/klaviyo.js?company_id=YnKpzp';
            k.async = true;
            document.head.appendChild(k);
          }
          $.magnificPopup.open({
            items: { src: '#klaviyo-oos-twostrong' },
            type: 'inline',
            /* Same scroll lock as the PDP opener — the page kept scrolling
               behind the popup without it. */
            callbacks: {
              open:  function () { document.documentElement.classList.add('ts-modal-lock'); },
              close: function () { document.documentElement.classList.remove('ts-modal-lock'); }
            }
          });
        });
      });
    })();
